import { render, staticRenderFns } from "./addapi.vue?vue&type=template&id=0fd9e446"
import script from "./addapi.vue?vue&type=script&lang=js"
export * from "./addapi.vue?vue&type=script&lang=js"
import style0 from "./addapi.vue?vue&type=style&index=0&id=0fd9e446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports